<template>
  <div>
    <nav-menu></nav-menu>

    <div style="margin-top: 43px;">
      <header class="w3-container w3-center">
        <h5>
          <i class="fa fa-code"/>
          <span>Logs do servidor/sessão</span>
        </h5>
      </header>

      <exibir-processando v-if="processando"/>

      <div class="w3-container">
      
        <div class="w3-col w3-margin-top w3-margin-bottom" v-if="logs_servidor_admweb && logs_servidor_admweb.conf_logs_servidor"> 
          <div class="w3-col" style="border-bottom: 2px dotted #a3a3a3;"/>
            <div class="w3-col s12">
              <i class="fa fa-cogs"/>
              <label>Configuração de logs</label>
            </div>
          <div class="w3-col" style="border-bottom: 2px dotted #a3a3a3; margin-bottom:10px;"/>

          <div class="w3-col s12">
            <i class="fa fa-sitemap"/>
            <label style="margin-left: 5px;">
              Tipo de logs servidor: <strong> {{logs_servidor_admweb.conf_logs_servidor.tipo_gravacao_log}} </strong>
            </label>
          </div>

          <div class="w3-col s12">
            <i class="fa fa-clock"/>
            <label style="margin-left: 5px;">
              Periodo de logs servidor: <strong> {{logs_servidor_admweb.conf_logs_servidor.periodo_gravacao_log}} </strong>
            </label>
          </div>

          <div class="w3-col s12">
            <i class="fa fa-cut"/>
            <label style="margin-left: 5px;">
              Limitar logs de sucesso: <strong> {{logs_servidor_admweb.conf_logs_servidor.cortar_logs_sucesso}} </strong>
            </label>
          </div>

          <div class="w3-col s12">
            <i class="fa fa-calendar-week"/>
            <label style="margin-left: 5px;">
              Qtd. dias manter logs do servidor: <strong> {{logs_servidor_admweb.conf_logs_servidor.qtd_dias_manter_logs}} </strong>
            </label>
          </div>
        </div>

        <div class="w3-col w3-margin-top w3-margin-bottom"> 

          <div class="w3-col" style="border-bottom: 2px dotted #a3a3a3;"/>
          <div class="w3-col s12">
            <i class="fa fa-power-off"/>
            <label>Logs de reinicialização</label>
          </div>
          <div class="w3-col" style="border-bottom: 2px dotted #a3a3a3; margin-bottom:10px;"/>

          <div style="margin-bottom:10px; cursor: pointer;" @click="mostrar_reinicializacao = !mostrar_reinicializacao">
            <i class="fa fa-folder" v-show="!mostrar_reinicializacao"/>
            <label v-show="!mostrar_reinicializacao"> Exibir logs de reinicialização</label>
            <i class="fa fa-folder-open" v-show="mostrar_reinicializacao"/>
            <label v-show="mostrar_reinicializacao"> Ocultar logs de reinicialização</label>
            
            <div class="w3-col s12 w3-center" v-show="!mostrar_reinicializacao">
              <i class="fa fa-ellipsis-h"/>
            </div>
          </div>

          <div class="w3-col" v-show="mostrar_reinicializacao">
            <label 
              v-if="!marcar_todos_reinicializacao"
              @click="marcarTodosReinicializacao()"
              style="text-decoration: underline; color: #429e42;"> 
              <i style="font-size: 14px;" class="fa fa-check-double"/>
              Marcar todos 
            </label>

            <label 
              v-if="marcar_todos_reinicializacao"
              @click="marcarTodosReinicializacao()"
              style="text-decoration: underline; color: #851830;"> 
              <i style="font-size: 14px;" class="fa fa-times"/>
              Desmarcar todos 
            </label>

            <div
              :key="index"
              class="w3-show w3-container"
              v-for="(log_reinicializacao, index) in logs_servidor_admweb.logs_reinicializacao">
              <div class="w3-col s12" v-on:click="selecionarReinicializacao(index)">
                <i
                  class="fa fa-dot-circle"
                  style="font-size: 14px; color: #383838;"
                  v-show="!log_reinicializacao.selecionado"
                />

                <i 
                  class="fa fa-check-circle"
                  style="font-size: 14px; color: #429e42;"
                  v-show="log_reinicializacao.selecionado"
                />

                <label style="margin-left: 5px;">
                  {{log_reinicializacao.log}}
                </label>
              </div>
            </div>

            <div class="w3-center">
              <button
                :disabled="processando"
                class="w3-button w3-indigo"
                @click="download('REINICIALIZACAO')">
                <i class="fas fa-download"/> Download
              </button>
            </div>
          </div>

          <div class="w3-col" style="margin-top: 10px; border-bottom: 2px dotted #a3a3a3;"/>
          <div class="w3-col s12">
            <i class="fa fa-user-shield"/>
            <label>Logs de sessão</label>
          </div>
          <div class="w3-col" style="border-bottom: 2px dotted #a3a3a3; margin-bottom:10px;"/>

          <div style="margin-bottom:10px; cursor: pointer;" @click="mostrar_sessao = !mostrar_sessao">
            <i class="fa fa-folder" v-show="!mostrar_sessao"/>
            <label v-show="!mostrar_sessao"> Exibir logs de sessão</label>
            <i class="fa fa-folder-open" v-show="mostrar_sessao"/>
            <label v-show="mostrar_sessao"> Ocultar logs de sessão</label>
            
            <div class="w3-col s12 w3-center" v-show="!mostrar_sessao">
              <i class="fa fa-ellipsis-h"/>
            </div>
          </div>

          <div class="w3-col" v-show="mostrar_sessao">

            <label 
              v-if="!marcar_todos_sessao"
              @click="marcarTodosSessao()"
              style="text-decoration: underline; color: #429e42;"> 
              <i style="font-size: 14px;" class="fa fa-check-double"/>
              Marcar todos 
            </label>

            <label 
              v-if="marcar_todos_sessao"
              @click="marcarTodosSessao()"
              style="text-decoration: underline; color: #851830;"> 
              <i style="font-size: 14px;" class="fa fa-times"/>
              Desmarcar todos 
            </label>

            <div
              :key="indexLogSessao"
              v-for="(log_sessao, indexLogSessao) in logs_servidor_admweb.logs_sessao">
              
              <div class="w3-col s12">
                <i
                  class="fa fa-dot-circle" 
                  v-show="!log_sessao.selecionado"
                  style="font-size: 14px; color: #383838;"
                  v-on:click="selecionarSessao('LogSessao', indexLogSessao)" 
                />

                <i 
                  class="fa fa-check-circle"
                  v-show="log_sessao.selecionado"
                  style="font-size: 14px; color: #429e42;"
                  v-on:click="selecionarSessao('LogSessao', indexLogSessao)"
                />

                <i 
                  class="fa fa-folder"
                  v-show="log_sessao.mostrarDetalhes"
                  style="font-size: 18px; color: #706234;"
                  v-on:click="alternarDetalhesSessao('LogSessao', indexLogSessao)"
                />

                <i 
                  class="fa fa-folder-open"
                  v-show="!log_sessao.mostrarDetalhes"
                  style="font-size: 18px; color: #706234;"
                  v-on:click="alternarDetalhesSessao('LogSessao', indexLogSessao)"
                />
                
                <label 
                  style="margin-left: 5px;"
                  v-on:click="alternarDetalhesSessao('LogSessao', indexLogSessao)">
                  {{log_sessao.data}}
                </label>

                <div v-show="!log_sessao.mostrarDetalhes">
                  <div
                    :key="indexLogUsuario"
                    class="w3-show w3-container"
                    v-for="(log_usuario, indexLogUsuario) in log_sessao.logs_usuarios">

                    <div class="w3-col s12">
                      <i
                        class="fa fa-dot-circle"
                        v-show="!log_usuario.selecionado"
                        style="font-size: 14px; color: #383838;"
                        v-on:click="selecionarSessao('LogUsuario', indexLogSessao, indexLogUsuario)" 
                      />

                      <i 
                        class="fa fa-check-circle"
                        v-show="log_usuario.selecionado"
                        style="font-size: 14px; color: #429e42;"
                        v-on:click="selecionarSessao('LogUsuario', indexLogSessao, indexLogUsuario)"
                      />

                      <i 
                        class="fa fa-folder"
                        v-show="log_usuario.mostrarDetalhes"
                        style="font-size: 17px; color: #706234;"
                        v-on:click="alternarDetalhesSessao('LogUsuario', indexLogSessao, indexLogUsuario)"
                      />

                      <i 
                        class="fa fa-folder-open"
                        v-show="!log_usuario.mostrarDetalhes"
                        style="font-size: 17px; color: #706234;"
                        v-on:click="alternarDetalhesSessao('LogUsuario', indexLogSessao, indexLogUsuario)"
                      />

                      <label 
                        style="margin-left: 5px;"
                        v-on:click="alternarDetalhesSessao('LogUsuario', indexLogSessao, indexLogUsuario)">
                        {{log_usuario.usuario_id}}
                      </label>

                      <div v-show="!log_usuario.mostrarDetalhes">
                        <div
                          :key="indexLog"
                          class="w3-show w3-container"
                          v-for="(log, indexLog) in log_usuario.logs"
                          v-on:click="selecionarSessao('Log', indexLogSessao, indexLogUsuario, indexLog)">

                          <i
                            class="fa fa-dot-circle"
                            v-show="!log.selecionado"
                            style="font-size: 14px; color: #383838;"
                          />

                          <i
                            v-show="log.selecionado"
                            class="fa fa-check-circle"
                            style="font-size: 14px; color: #429e42;"
                          />

                          <label style="margin-left: 5px;">{{log.log}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="w3-col" style="border-bottom: 2px dotted #a3a3a3; margin-bottom:10px;"/>
              </div>

            </div>

            <div class="w3-center">
              <button
                :disabled="processando"
                @click="download('SESSAO')"
                class="w3-button w3-indigo"> 
                <i class="fas fa-download"/> Download
              </button>
            </div>
          </div>
        </div>
      </div>

       <button 
        id="floating-button" 
        title="Buscar pasta de logs" 
        v-on:click="buscarPastasLogs()" 
        style="border-radius: 50% !important"
        class="w3-button w3-theme w3-circle w3-display-bottomright">
        <i class="fa fa-sync-alt"></i>
      </button>
    </div>
  </div>
</template>

<script>
  import NavMenu from '@/components/Menu';
  import RLogServidor from '@/components/Rest/RLogServidor.js'
  import ExibirProcessando from '@/components/ExibirProcessando'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'

  export default {
    name: 'LogServidor',

    components: {
      NavMenu, 
      ExibirProcessando
    },
    
    data () {
      return {
        marcar_todos_sessao: false,
        marcar_todos_reinicializacao: false,
        mostrar_reinicializacao: false,
        mostrar_sessao: false,
        processando: false,
        logs_servidor_admweb: {}
      }
    },

    methods: {
      async buscarPastasLogs(){
        try {
          this.processando = true;
          let retorno = await RLogServidor.buscarPastasLogs(this.axios);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }
        
          this.logs_servidor_admweb = JSON.parse(JSON.stringify(retorno.dados));
          this.processando = false;
        } catch (error) {
          this.processando = false;
          Biblioteca.exclamar(error.message);  
        }
      },

      async download(tipoLogs){
        try {
          this.processando = true;
          console.log('processando = true')
          let logsSelecionados = [];

          if (tipoLogs == 'REINICIALIZACAO'){
            for (let i = 0; i < this.logs_servidor_admweb.logs_reinicializacao.length; i++){
              if (this.logs_servidor_admweb.logs_reinicializacao[i].selecionado){
                logsSelecionados.push(this.logs_servidor_admweb.logs_reinicializacao[i].log);    
              }
            }
          } else if (tipoLogs == 'SESSAO'){
            for (let i = 0; i < this.logs_servidor_admweb.logs_sessao.length; i++){
              for (let j = 0; j < this.logs_servidor_admweb.logs_sessao[i].logs_usuarios.length; j++){
                for (let x = 0; x < this.logs_servidor_admweb.logs_sessao[i].logs_usuarios[j].logs.length; x++){
                  if (this.logs_servidor_admweb.logs_sessao[i].logs_usuarios[j].logs[x].selecionado){
                    logsSelecionados.push(
                      this.logs_servidor_admweb.logs_sessao[i].data + '/' + 
                      this.logs_servidor_admweb.logs_sessao[i].logs_usuarios[j].usuario_id + '/' +
                      this.logs_servidor_admweb.logs_sessao[i].logs_usuarios[j].logs[x].log
                    ); 
                  }
                }
              }
            }
          }

          if (logsSelecionados.length == 0){
            throw new Error('Nenhum arquivo de log foi selecionado!');   
          }
          
          let parametros = {
            tipo_log: tipoLogs,
            logs_selecionados: logsSelecionados
          };

          let retorno = await RLogServidor.downloadArquivosLogs(process.env.API, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.processando = false;
        } catch (error) {
          this.processando = false;
          Biblioteca.exclamar(error.message);  
        }
      },

      async alternarDetalhesSessao(tipo, indexLogSessao, indexLogUsuario, indexLog){
        try{
          if (tipo == 'LogSessao') {
            this.logs_servidor_admweb.logs_sessao[indexLogSessao].mostrarDetalhes = this.logs_servidor_admweb.logs_sessao[indexLogSessao].mostrarDetalhes ? false : true; 
          } else if (tipo == 'LogUsuario'){
            this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios[indexLogUsuario].mostrarDetalhes = this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios[indexLogUsuario].mostrarDetalhes ? false : true;
          }

          this.$forceUpdate(); 
        } catch (error) {
          Biblioteca.exclamar(error.message);   
        }
      },

      async selecionarSessao(tipo, indexLogSessao, indexLogUsuario, indexLog){
        try{
          let todos_selecionados = false;

          if (tipo == 'LogSessao'){
            this.logs_servidor_admweb.logs_sessao[indexLogSessao].selecionado = this.logs_servidor_admweb.logs_sessao[indexLogSessao].selecionado ? false : true;

            for (let i = 0; i < this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios.length; i++){
              this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios[i].selecionado = this.logs_servidor_admweb.logs_sessao[indexLogSessao].selecionado;
              
              for (let j = 0; j < this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios[i].logs.length; j++){
                this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios[i].logs[j].selecionado = this.logs_servidor_admweb.logs_sessao[indexLogSessao].selecionado;
              }
            }
          } else if (tipo == 'LogUsuario'){
            this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios[indexLogUsuario].selecionado = this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios[indexLogUsuario].selecionado ? false : true;

            for (let i = 0; i < this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios[indexLogUsuario].logs.length; i++){
              this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios[indexLogUsuario].logs[i].selecionado = this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios[indexLogUsuario].selecionado;
            }
          } else if (tipo == 'Log'){
            this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios[indexLogUsuario].logs[indexLog].selecionado = this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios[indexLogUsuario].logs[indexLog].selecionado ? false : true;

            if (this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios[indexLogUsuario].logs[indexLog].selecionado){
              todos_selecionados = true;
              for (let i = 0; i < this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios[indexLogUsuario].logs.length; i++){
                if (!this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios[indexLogUsuario].logs[i].selecionado){
                  todos_selecionados = false;
                  break;
                }
              }
              
              this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios[indexLogUsuario].selecionado = todos_selecionados;
            } else {
              this.logs_servidor_admweb.logs_sessao[indexLogSessao].selecionado = false;
              this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios[indexLogUsuario].selecionado = false;
            }
          }

          todos_selecionados = true;
          for (let i = 0; i < this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios.length; i++){
            if (!this.logs_servidor_admweb.logs_sessao[indexLogSessao].logs_usuarios[i].selecionado){
              todos_selecionados = false;
              break;
            }
          }

          this.logs_servidor_admweb.logs_sessao[indexLogSessao].selecionado = todos_selecionados;
          this.$forceUpdate();
        } catch (error) {
          Biblioteca.exclamar(error.message);   
        }
      },

      async selecionarReinicializacao(index){
        this.logs_servidor_admweb.logs_reinicializacao[index].selecionado = this.logs_servidor_admweb.logs_reinicializacao[index].selecionado ? false : true;
        this.$forceUpdate();
      },

      async marcarTodosReinicializacao(){
        this.marcar_todos_reinicializacao = !this.marcar_todos_reinicializacao;

        for (let i = 0; i < this.logs_servidor_admweb.logs_reinicializacao.length; i++){
          this.logs_servidor_admweb.logs_reinicializacao[i].selecionado = this.marcar_todos_reinicializacao;
        }

        this.$forceUpdate();
      },

      async marcarTodosSessao(){
        this.marcar_todos_sessao = !this.marcar_todos_sessao;

        for (let i = 0; i < this.logs_servidor_admweb.logs_sessao.length; i++){
          this.logs_servidor_admweb.logs_sessao[i].selecionado = this.marcar_todos_sessao;

          for (let j = 0; j < this.logs_servidor_admweb.logs_sessao[i].logs_usuarios.length; j++){
            this.logs_servidor_admweb.logs_sessao[i].logs_usuarios[j].selecionado = this.marcar_todos_sessao;
            
            for (let x = 0; x < this.logs_servidor_admweb.logs_sessao[i].logs_usuarios[j].logs.length; x++){
              this.logs_servidor_admweb.logs_sessao[i].logs_usuarios[j].logs[x].selecionado = this.marcar_todos_sessao;
            }
          }
        }

        this.$forceUpdate();
      },
    },

    async created() {
      await this.buscarPastasLogs();  
    }
  }
</script>

<style scoped>
  .card-item {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
    cursor: pointer;
  }
  
  #floating-button {
    z-index: 5 !important;
    padding-left: 14px!important; 
    padding-top: 7px!important; 
    font-size: 19px; 
    border-radius: 30px; 
    width:55px; 
    height:55px; 
    border: 4px solid #f7f7f7!important; 
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }

  #floating-button:hover {
    color: #9c1d1c!important;
  }
</style>


// WEBPACK FOOTER //
// src/components/LogServidor.vue